import RateInspectorComponent from '@/components/Pages/RateInspector.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/inspector/:inspectorId/rate',
  props: true,
  name: RouteNames.RateInspector,
  component: RateInspectorComponent,
};

export default route;
